import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Tooltip } from "@msuite/ui/tooltip";
import type { PropsWithChildren } from "react";

function LastInvoice() {
	return <p>Last Invoice</p>;
}

function LastInvoiceWrapper({ children }: PropsWithChildren) {
	return <div className="h-stack">{children}</div>;
}

interface LastInvoiceProgressInvoiceItemProps {
	last: string;
	next: string;
	isOverdue?: boolean;
}

LastInvoice.ProgressInvoiceItem = function ({
	last,
	next,
	isOverdue,
}: LastInvoiceProgressInvoiceItemProps) {
	const { t } = useTranslation();

	/** Render */
	return (
		<LastInvoiceWrapper>
			{isOverdue && (
				<Tooltip label={t("invoices.overdue")}>
					<Icon
						name="Asterisk"
						className="stroke-rose-500 fill-rose-500/10"
					/>
				</Tooltip>
			)}
			<Icon
				name="Calendar"
				className="stroke-emerald-500 fill-emerald-500/10"
			/>
			<p>{last}</p>
			<Icon
				name="ArrowRight"
				className="stroke-primary-500"
			/>
			<p>{next}</p>
		</LastInvoiceWrapper>
	);
};

LastInvoice.Header = function () {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<LastInvoice.ProgressInvoiceItem
			last={t("projects.last_invoice")}
			next={t("projects.next_possible_invoice")}
		/>
	);
};

LastInvoice.FinalInvoiceItem = function () {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<LastInvoiceWrapper>
			<Icon
				name="SquareCheck"
				className="stroke-blue-500 fill-blue-500/10"
			/>
			<p>{t("projects.has_final_invoice")}</p>
		</LastInvoiceWrapper>
	);
};

LastInvoice.SingleInvoiceItem = function () {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<LastInvoiceWrapper>
			<Icon
				name="SquareCheck"
				className="stroke-blue-500 fill-blue-500/10"
			/>
			<p>{t("projects.has_single_invoice")}</p>
		</LastInvoiceWrapper>
	);
};

LastInvoice.NoInvoicesItem = function () {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<LastInvoiceWrapper>
			<Icon
				name="Flag"
				className="stroke-rose-500 fill-rose-500/10"
			/>
			<p>{t("projects.no_invoices_yet")}</p>
		</LastInvoiceWrapper>
	);
};

export { LastInvoice };
